"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.withSearchFacetProviders = void 0;

var _react = _interopRequireWildcard(require("react"));

var _recompose = require("@hypnosphi/recompose");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var withSearchFacetProviders = function withSearchFacetProviders(BaseComponent) {
  return function (_ref) {
    var facets = _ref.facets,
        searchCriteria = _ref.searchCriteria,
        rest = _objectWithoutProperties(_ref, ["facets", "searchCriteria"]);

    var _useMemo = (0, _react.useMemo)(function () {
      return facets.reduce(function (acc, _ref2) {
        var tag = _ref2.tag,
            makeCriteriaProvider = _ref2.makeCriteriaProvider,
            facetRest = _objectWithoutProperties(_ref2, ["tag", "makeCriteriaProvider"]);

        if (!makeCriteriaProvider) {
          acc.contextualFacets.push(_objectSpread({
            tag: tag,
            context: null
          }, facetRest));
          return acc;
        }

        var _ref3 = searchCriteria || {},
            criterions = _ref3.criterions;

        var context = /*#__PURE__*/_react["default"].createContext({
          options: [],
          matchOption: function matchOption() {},
          selected: criterions && criterions[tag] ? criterions[tag] : [],
          setSelected: function setSelected() {}
        });

        var withProvider = makeCriteriaProvider(tag, context);
        acc.providers.push(withProvider);
        acc.contextualFacets.push(_objectSpread({
          tag: tag,
          context: context
        }, facetRest));
        return acc;
      }, {
        providers: [],
        contextualFacets: []
      });
    }, [facets, searchCriteria]),
        providers = _useMemo.providers,
        contextualFacets = _useMemo.contextualFacets;

    var ComponentWithFacetProviders = (0, _react.useMemo)(function () {
      return _recompose.compose.apply(void 0, _toConsumableArray(providers))(BaseComponent);
    }, [providers]);
    var props = (0, _react.useMemo)(function () {
      return _objectSpread({
        facets: contextualFacets,
        searchCriteria: searchCriteria
      }, rest);
    }, [contextualFacets, searchCriteria, rest]);
    return /*#__PURE__*/_react["default"].createElement(ComponentWithFacetProviders, props);
  };
};

exports.withSearchFacetProviders = withSearchFacetProviders;
var _default = withSearchFacetProviders;
exports["default"] = _default;